import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useToast } from "../../../Toaster/ToastContext";
import { apiClient } from "../../../services/apiClient";

const Forgotpassword = () => {
  const route = all_routes;
  const { showToast } = useToast(); 
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "" });
  const [isLoading, setIsLoading] = useState(false);

  const validateField = (name, value) => {
    switch (name) {
      case "email":
        return value.trim() ? "" : "Email is required";
      default:
        return "";
    }
  };

  const validateForm = () => {
    const newErrors = {
      email: validateField("email", email),
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      try {
        let data = {
          email: email
        }
        const response = await apiClient.post("/password-reset-email", data);
        const apiData = await response;
        if (apiData.success) {
          showToast(
            apiData.message || "Password reset email sent successfully!",
            "success",
            "Password Reset"
          );
          // setEmail("");
          setErrors({ email: "" });
        } else {
          showToast(
            apiData.message || "Failed to send password reset email",
            "error",
            "Password Reset"
          );
        }
      } catch (error) {
        showToast(
          error.message ||
            "An unexpected error occurred. Please contact the support team.",
          "error",
          "Password Reset"
        );
      } finally {
        setEmail("");
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper forgot-pass-wrap bg-img">
          <div className="login-content">
            <form onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt />
                </Link>
                <div className="login-userheading">
                  <h3>Forgot password?</h3>
                  <h4>
                    If you forgot your password, we’ll email you instructions to
                    reset your password.
                  </h4>
                </div>
                <div className="form-login">
                  <label>Email</label>
                  <div className="form-addons">
                    <input
                      type="email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrors({ email: validateField("email", e.target.value) });
                      }}
                    />
                    <ImageWithBasePath src="assets/img/icons/mail.svg" alt="img" />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>
                </div>
                <div className="form-login">
                  <button
                    type="submit"
                    className="btn btn-login"
                    disabled={isLoading}
                  >
                    {isLoading ? "Sending..." : "Send Email"}
                  </button>
                </div>
                <div className="signinform text-center">
                  <h4>
                    Return to &nbsp;
                    <Link to={route.signin} className="hover-a">
                      login
                    </Link>
                  </h4>
                </div>
                {/* <div className="form-setlogin or-text">
                   <h4>OR</h4>
                 </div>
                 <div className="form-sociallink">
                   <ul className="d-flex justify-content-center">
                     <li>
                       <Link to="#" className="facebook-logo">
                         <ImageWithBasePath
                           src="assets/img/icons/facebook-logo.svg"
                           alt="Facebook"
                         />
                       </Link>
                     </li>
                     <li>
                       <Link to="#">
                         <ImageWithBasePath
                           src="assets/img/icons/google.png"
                           alt="Google"
                         />
                       </Link>
                     </li>
                     <li>
                       <Link to="#" className="apple-logo">
                         <ImageWithBasePath
                           src="assets/img/icons/apple-logo.svg"
                           alt="Apple"
                         />
                       </Link>
                     </li>
                   </ul>
                 </div>
                 <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                   <p>Copyright © 2023 DreamsPOS. All rights reserved</p>
                 </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forgotpassword;
